<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="音频上传" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <div class="audio-uploader">
        <van-uploader :after-read="afterRead" accept="audio/mpeg,audio/ogg,application/ogg">
          <div class="audio-btn">
            <van-image
              width="120px"
              height="120px"
              fit="contain"
              :src="require('@/assets/images/audio.png')"
            />
            <span class="t15 c6 martop10">{{name}}</span>
          </div>
        </van-uploader>
      </div>

      <van-field
        v-model="title"
        placeholder="音频名称"
      />
      <van-field
        v-model="Singer"
        placeholder="作者名称"
      />
      <van-field
        v-model="description"
        rows="5"
        autosize
        type="textarea"
        maxlength="150"
        placeholder="音频描述"
      />
      <div class="btn-area">
        <van-button round block class="mybtn" native-type="submit" @click="onsubmit" >
          确定
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant'
	export default {
	  data() {
	    return {
        title:'',
        description :'',
        music : null,
        name:"上传音频",
        Singer:"",
	    };
	  },
	  components: {
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      //
      onsubmit(){
        var that = this;
        if(that.title == ''){
          Toast('音频名称不能为空');
          return;
        }
        if(that.music == null){
          Toast('请选择音频');
          return;
        }
        this.$store.dispatch({
          type:"MusicInfoMusicInfoAddVue",
          Id : that.id,
          Title : that.title,
          Description : that.description,
          Singer : that.Singer,
          Base64Content : that.music,
        }).then(res => {
          if(res.IsSuccess){
            that.$router.go(-1);
          }
        }, err => {})


      },
      afterRead(file) {
        // 此时可以自行将文件上传至服务器
        var that = this;
        this.music = file.content;
        this.name = file.file.name;
      }
    },
    created(){
      var that = this;
      this.id = this.$route.params.id;
    }
	};
</script>

<style scoped>
.audio-uploader{
  padding: 20px;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.audio-btn{
  flex: 1;
  padding: 20px;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
